module.exports = __webpack_public_path__ + "assets/ic_tree24.de69e502.svg";